<template>
  <ui-component-modal
    :modalTitle="$t('Components.Terms.EditTerms.Name.Main_Title')"
    :disableSaveButton="mTerm.Version.length < 2"
    :onClickCancel="onClickCancel"
    :onClickSave="saveTerm"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template v-slot:content>
      <ui-base-input-field
        v-if="mTerm"
        v-model="mTerm.Version"
        :error="nameErrors"
        :required="true"
        :showLabel="false"
        fieldType="text"
        @keyup.enter="saveTerm"
        @input="$v.mTerm.Version.$touch()"
        @blur="$v.mTerm.Version.$touch()"
      />
    </template>
  </ui-component-modal>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import termsProvider from '@/providers/terms'

import { required, minLength } from 'vuelidate/lib/validators'
const touchMap = new WeakMap()

export default {
  components: {},

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    onClickCancel: {
      type: Function,
      required: true,
    },

    term: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      mTerm: null,
    }
  },

  /**
   * Form validation rules
   */
  validations() {
    let output = {
      Version: {
        required,
        minLength: minLength(2),
      },
    }
    return {
      mTerm: output,
    }
  },

  computed: {
    nameErrors() {
      const errors = []
      if (this.mTerm) {
        if (!this.$v.mTerm.Version.$dirty) return errors
        !this.$v.mTerm.Version.required &&
          errors.push(this.$t('Form.InputErrors.Required'))
        !this.$v.mTerm.Version.minLength &&
          errors.push(this.$t('Form.InputErrors.minLength', { minLength: 2 }))
      }
      return errors
    },
  },

  created() {
    if (this.term) {
      this.mTerm = JSON.parse(JSON.stringify(this.term))
    }
  },

  methods: {
    saveTerm() {
      let self = this

      if (!self.isSaving) {
        self.isSaving = true
        this.$v.$touch()
        if (this.$v.$invalid) {
          // 'ERROR'
          self.isSaving = false
        } else {
          termsProvider.methods
            .updateTerm(self.mTerm)
            .then((response) => {
              if (response.status === 200) {
                self.$emit('termUpdated', response.data)

                self.onClickCancel()
              }
            })
            .catch((e) => {
              // //console.log(error.response)
              self.isSavingError = true
            })
            .finally(() => {
              self.isSaving = false
            })
        }
      }
    },
  },
}
</script>
